<template>
  <div class="content-wrapper">
    <h2 class="page-titles">Manage inventory and store</h2>

    <div class="flex items-center justify-between search-region-holder">
      <div class="search-region">
        <SearchAndFilter
          :placeholder="'Search by product title'"
          :showDate="false"
        />
      </div>
    </div>

    <div class="margin-top-4">
      <div class="tabs">
        <div class="tab">
          <label for="tab-1" class="editorial">Inventory</label>
          <input id="tab-1" name="tabs-two" type="radio" checked="checked" />
          <ProductInventory />
        </div>
        <div class="tab">
          <label for="tab-2" class="editorial">Store</label>
          <input id="tab-2" name="tabs-two" type="radio" />
          <StoreInventory />
        </div>
      </div>
    </div>
    <ExportModal
      :showFooter="true"
      v-show="isExportModalActive"
      @hideModal="closeModal"
      :showCancelButton="false"
      @confirmAction="closeModal"
      colorVariation="coast"
    >
      <template slot="header">
        <span>Exporting Inventory</span>
      </template>

      <template slot="body">
        <span
          >Your inventory report is now being generated and you will receive a
          download link at <strong> {{ user.email }} </strong> when it's ready.
          Keep an eye on your inbox!
        </span>
      </template>
    </ExportModal>
  </div>
</template>

<script>
import { layouts, storeModules } from '@/helpers'
import { mapState } from 'vuex'
import store from '../store'
import moment from 'moment'

export default {
  name: 'InventoryMain',
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (
      store.state.team.team.teamModuleNames.includes(storeModules.swag_store)
    ) {
      next()
    } else if (
      store.state.team.team.teamModuleNames.includes(storeModules.project)
    ) {
      next({ name: 'Projects' })
    }
  },

  components: {
    SearchAndFilter: () => import('@/components/Universal/SearchAndFilter'),
    ProductInventory: () => import('@/components/Inventory/ProductInventory'),
    StoreInventory: () => import('@/components/Inventory/StoreInventory'),
    ExportModal: () => import('@/components/Universal/ExportModal')
  },

  data: () => ({
    file_fields: ['title', 'variantName', 'quantity', 'cost', 'uuid'],
    file_labels: {
      title: 'Product Name',
      variantName: 'Variant Name',
      quantity: 'Quantity',
      cost: 'Cost',
      uuid: 'External Product ID'
    }
  }),

  methods: {
    handleExport() {
      this.$store.dispatch('modal/handleExports', 'team_inventory')
    },
    closeModal() {
      this.$store.dispatch('modal/setExportModal', false)
    }
  },
  computed: {
    teamName() {
      return this.$store.getters['team/teamName']
    },
    fileName() {
      return `${this.teamName}-inventory-${moment().format('MM-DD-YYYY')}.csv`
    },
    export_data() {
      let data = []
      data = this.productinventoryList.map(product => {
        return {
          title: product.title,
          variantName: product.variantName,
          quantity: product.quantity,
          cost: product.cost,
          uuid: product.uuid
        }
      })
      return data
    },

    ...mapState({
      productinventoryList: state => state.inventory.productInventoryList,
      user: state => state.profile.user,
      isExportModalActive: state => state.modal.isExportModalActive
    })
  },

  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD)
  }
}
</script>

<style lang="scss" scoped>
@import '../global.scss';
.search-region-holder {
  padding-top: 1rem;
  .search-region {
    width: 30%;
  }
}

.button-gemnote {
  background: $main-white;
  color: $main-6;
  width: auto;
  padding: 0 1.25rem;
  height: 2.5rem;

  &:hover {
    background: $main-white;
    color: $main-6;
  }
}

label {
  font-weight: 400 !important;
}

@media screen and (max-width: 1450px) and (min-width: 350px) {
  .content-wrapper {
    padding-right: 0;
  }
}

@media (max-width: 1100px) {
  form {
    width: 100%;
  }
}
</style>
